import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import PersonIcon from "@material-ui/icons/Person";
import ListAltIcon from "@material-ui/icons/ListAlt";

import { Display } from "./types";
import type { MenuItem, Modules } from "./types";
import { ListSubheader } from "@material-ui/core";

const menuItemList: MenuItem[] = [
  {
    subheader: "Amil",
    menu: [
      {
        key: Display.AmilList,
        text: "Senarai Amil",
        icon: <PersonIcon />,
        module: "amil.list",
      },
    ],
    module: "amil",
  },
  {
    subheader: "Kutipan",
    menu: [
      {
        key: Display.CollectionFitrah,
        text: "Fitrah",
        icon: <ListAltIcon />,
        module: "report.fitrah",
      },
    ],
    module: "report",
  },
];

interface Props {
  modules: Modules;
  focus: Display;
  onClick: (key: Display) => void;
}

const checkModule = (target: string, modules: Modules): boolean => {
  const needle = Object.keys(modules).find((key) => target === key);
  return needle !== undefined;
};

const checkSubmodule = (
  parent: string,
  target: string,
  modules: Modules
): boolean => {
  const group = Object.keys(modules).find((key) => parent === key);
  if (group === undefined) {
    return false;
  }

  const needle = modules[group].find((key) => target === key);
  return needle !== undefined;
};

function Sidebar({ modules, focus, onClick }: Props) {
  const view = menuItemList.map((item) => {
    if (!checkModule(item.module, modules)) {
      return null;
    }

    return (
      <React.Fragment key={item.subheader}>
        <List>
          <ListSubheader>{item.subheader}</ListSubheader>
          {item.menu.map((link) => {
            if (!checkSubmodule(item.module, link.module, modules)) {
              return null;
            }

            return (
              <ListItem
                button
                key={link.key}
                selected={focus === link.key}
                onClick={() => onClick(link.key)}
              >
                <ListItemIcon>{link.icon}</ListItemIcon>
                <ListItemText primary={link.text} />
              </ListItem>
            );
          })}
        </List>
        <Divider />
      </React.Fragment>
    );
  });

  return <>{view}</>;
}

export default Sidebar;
